export default "__VITE_ASSET__Dk6xw1ut__"